export default {
  appBootGuard(store, next) {
    if (store.state.settingsLoaded) return next();

    // Loads initial app configuration
    return store.dispatch('bootstrapApp').then(() => next());
  },
};
